/**
 * Created by Teo on 04/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadManagementAggregatedGrid', {
                parent: 'leadManagementAggregated',
                url: '',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadManagementAggregated/grid/grid.html',
                controller: 'LeadManagementAggregatedGridController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
